export default __webpack_public_path__ + "8ee0e46c9450c52db6f29184de27555d.jpg";